import React, { ChangeEvent, Component } from 'react';
import { ContentNameFieldProps, ContentNameFieldState, InjectedProps } from './ContentNameFieldModel';
import { Input } from 'antd';
import { withPermissionsToInteract } from '../../providers/UserPermissionsProvider';
import { withDisabledPropertyInContentForm } from '@hoc/withDisabledPropertyInContentForm';

class ContentNameField extends Component<ContentNameFieldProps, ContentNameFieldState> {
    get injected() {
        return this.props as InjectedProps;
    }

    customOnChange = (e: ChangeEvent<HTMLInputElement>) => {
        this.props.nameField.setFieldValue(e.target.value);
        return this.injected.onChange(e.target.value);
    }

    onBlur = (e: ChangeEvent<HTMLInputElement>) => {
        const trimmedValue = this.props.nameField.trimValue(e.target.value);
        return this.injected.onChange(trimmedValue);
    }

    render() {
        const { nameField, hasPermissions, archived, ...others } = this.props;
        const disabled = archived || !hasPermissions;
        return (
            <Input
                {...others}
                disabled={disabled}
                type="text"
                value={nameField.value}
                onChange={this.customOnChange}
                onBlur={this.onBlur}
            />
        );
    }
}

export default withDisabledPropertyInContentForm(withPermissionsToInteract(ContentNameField));
